import { render, staticRenderFns } from "./ManageAllModels.vue?vue&type=template&id=2e677c32&scoped=true"
import script from "./ManageAllModels.vue?vue&type=script&lang=js"
export * from "./ManageAllModels.vue?vue&type=script&lang=js"
import style0 from "./ManageAllModels.vue?vue&type=style&index=0&id=2e677c32&prod&lang=css"
import style1 from "./ManageAllModels.vue?vue&type=style&index=1&id=2e677c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e677c32",
  null
  
)

export default component.exports